import React from 'react'
import {useIntl, FormattedMessage} from 'react-intl'
import TextField from '@material-ui/core/TextField'
import {makeStyles} from '@material-ui/core/styles'
import Grid from '@material-ui/core/Grid'
import LoaderButton from 'components/atoms/LoaderButton'
import {Link as RouterLink} from 'react-router-dom'
import Link from '@material-ui/core/Link'
import {Formik} from 'formik'
import * as Yup from 'yup'

const SignUpSchema = Yup.object().shape({
  email: Yup.string()
    .email('formValidations.invalidEmail')
    .required('formValidations.required'),
  password: Yup.string()
    .min(8, 'formValidations.passwordTooShort')
    .required('formValidations.required'),
})

const useStyles = makeStyles(theme => ({
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
}))

export function SignUpForm({onSubmit}) {
  const classes = useStyles()
  const intl = useIntl()

  return (
    <>
      <Formik
        initialValues={{email: '', password: ''}}
        validationSchema={SignUpSchema}
        onSubmit={onSubmit}
      >
        {({
          values,
          errors,
          touched,
          handleChange,
          handleBlur,
          handleSubmit,
          isSubmitting,
        }) => (
          <form onSubmit={handleSubmit} className={classes.form} noValidate>
            <TextField
              variant="outlined"
              margin="normal"
              required
              fullWidth
              id="email"
              label={intl.formatMessage({id: 'email'})}
              name="email"
              autoComplete="email"
              autoFocus
              value={values.email}
              onChange={handleChange}
              onBlur={handleBlur}
              error={touched.email && Boolean(errors.email)}
              helperText={
                touched.email && errors.email && intl.formatMessage({id: errors.email})
              }
            />
            <TextField
              variant="outlined"
              margin="normal"
              required
              fullWidth
              name="password"
              label={intl.formatMessage({id: 'password'})}
              type="password"
              id="password"
              autoComplete="new-password"
              value={values.password}
              onChange={handleChange}
              onBlur={handleBlur}
              error={touched.password && Boolean(errors.password)}
              helperText={
                touched.password &&
                errors.password &&
                intl.formatMessage({id: errors.password})
              }
            />
            <LoaderButton
              type="submit"
              isLoading={isSubmitting}
              fullWidth
              variant="contained"
              color="primary"
              loadingText="Signing up…"
              className={classes.submit}
            >
              <FormattedMessage id="signUp.button" />
            </LoaderButton>
          </form>
        )}
      </Formik>
      <Grid container justify="flex-end">
        <Grid item>
          <Link to="/login" variant="body2" component={RouterLink}>
            <FormattedMessage id="signUp.loginLink" />
          </Link>
        </Grid>
      </Grid>
    </>
  )
}

export default SignUpForm
